module.exports = __webpack_public_path__ + "img/08.cff60a89.svg";